module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Tecknau-e7a4b1a22162a41ab7976f899a71e5ce.svg";